import { BasicReferencedEntityDataStringId } from "api";

import { daysAgo } from "lib/helpers";
import { ExhMeasurementValue, ExhMeasurementWbcResult } from "types/measurement";
import { Measurement, PatientResult } from "types/patient";

const emptyMeasurement: Measurement = { value: "" };

const toMeasurement = (raw: ExhMeasurementValue | undefined, resultId: string): Measurement => {
  if (!raw) {
    return emptyMeasurement;
  }
  return {
    value: raw.value ?? "",
    unit: raw.unit,
    measurementInterval: {
      id: resultId,
      outOfRange: Boolean(raw.measurement_interval?.out_of_range),
    },
  };
};

export const convertExhWbcResultToPatientResult = (doc: ExhMeasurementWbcResult): PatientResult => {
  const data = doc.data ?? {};
  const dateRecorded = data.measurement_timestamp ?? "";

  return {
    id: doc.id,
    dateRecorded,
    daysAgo: dateRecorded ? daysAgo(dateRecorded) : undefined,
    whiteBloodCells: toMeasurement(data.white_blood_cells, doc.id),
    granulocytes: toMeasurement(data.granulocytes, doc.id),
    neutrophils: { ...emptyMeasurement },
    haemoglobin: { ...emptyMeasurement },
    platelets: { ...emptyMeasurement },
    belowNeutrophilThreshold: null,
    device: data.device_id ? ({ id: data.device_id } as BasicReferencedEntityDataStringId) : undefined,
  };
};
